
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0A1628 0%, #1E3A5F 100%)'
      }}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center">
          {/* Main Title */}
          <div className="space-y-2 mb-6">
            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight">
              Secure Your
            </h1>
            <h1 className="text-5xl lg:text-7xl font-bold text-[#00D4FF] leading-tight">
              Digital Freedom
            </h1>
            <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight">
              With BALESTRA VPN
            </h1>
          </div>

          {/* Subtitle */}
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
            Enterprise-grade encryption for your privacy
          </p>

          {/* CTA Button */}
          <div className="mb-16">
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => scrollToSection('contact')}
            >
              Start Protecting Now
              <i className="ri-arrow-right-line"></i>
            </Button>
          </div>

          {/* VPN Interface Mockups */}
          <div className="relative max-w-4xl mx-auto">
            <div className="flex items-end justify-center space-x-4">
              {/* Left Card */}
              <div className="transform -rotate-12 translate-y-8 opacity-85">
                <div className="w-64 h-80 bg-white rounded-3xl shadow-2xl p-6">
                  <div className="bg-gradient-to-br from-[#1A4D7C] to-[#00D4FF] rounded-2xl h-full p-4 text-white">
                    <div className="flex items-center justify-between mb-4">
                      <div className="w-8 h-8 bg-white/20 rounded-full"></div>
                      <div className="text-xs bg-green-500 px-2 py-1 rounded-full">CONNECTED</div>
                    </div>
                    <div className="text-center mt-12">
                      <div className="text-2xl font-bold mb-2">Serbia</div>
                      <div className="text-sm opacity-80">Belgrade Server</div>
                      <div className="mt-8 space-y-2">
                        <div className="bg-white/20 h-2 rounded-full"></div>
                        <div className="bg-white/20 h-2 rounded-full w-3/4"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Center Card (Main) */}
              <div className="transform scale-110">
                <div className="w-72 h-96 bg-white rounded-3xl shadow-2xl p-6">
                  <div className="bg-gradient-to-br from-[#0A1628] to-[#1E3A5F] rounded-2xl h-full p-6 text-white">
                    <div className="text-center">
                      <img 
                        src="https://public.readdy.ai/ai/img_res/18fbafa5-fe56-4ee6-aedd-9bee74ac04df.png" 
                        alt="BALESTRA Logo"
                        className="w-12 h-12 mx-auto mb-4"
                      />
                      <div className="text-lg font-bold mb-2">BALESTRA VPN</div>
                      <div className="text-sm text-gray-300 mb-8">Ultimate Protection</div>
                      
                      <div className="space-y-4">
                        <div className="bg-green-500 text-white px-4 py-3 rounded-lg">
                          <div className="flex items-center justify-center">
                            <i className="ri-shield-check-line mr-2"></i>
                            <span className="font-medium">Protected</span>
                          </div>
                        </div>
                        
                        <div className="bg-white/10 p-4 rounded-lg">
                          <div className="text-xs text-gray-300 mb-1">Current Server</div>
                          <div className="font-medium">Serbia - Belgrade</div>
                          <div className="text-xs text-gray-300 mt-2">Latency: 12ms</div>
                        </div>
                        
                        <div className="grid grid-cols-2 gap-2 text-xs">
                          <div className="bg-white/5 p-2 rounded">
                            <div className="text-gray-300">Upload</div>
                            <div className="font-bold text-[#00D4FF]">245 MB/s</div>
                          </div>
                          <div className="bg-white/5 p-2 rounded">
                            <div className="text-gray-300">Download</div>
                            <div className="font-bold text-[#00D4FF]">512 MB/s</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Card */}
              <div className="transform rotate-12 translate-y-8 opacity-85">
                <div className="w-64 h-80 bg-white rounded-3xl shadow-2xl p-6">
                  <div className="bg-gradient-to-br from-[#1A4D7C] to-[#00D4FF] rounded-2xl h-full p-4 text-white">
                    <div className="flex items-center justify-between mb-4">
                      <div className="text-xs bg-[#00D4FF] px-2 py-1 rounded-full">SECURE</div>
                      <div className="w-8 h-8 bg-white/20 rounded-full"></div>
                    </div>
                    <div className="text-center mt-12">
                      <div className="text-2xl font-bold mb-2">Global</div>
                      <div className="text-sm opacity-80">50+ Countries</div>
                      <div className="mt-8 grid grid-cols-3 gap-2">
                        <div className="bg-white/20 h-8 rounded"></div>
                        <div className="bg-white/20 h-8 rounded"></div>
                        <div className="bg-white/20 h-8 rounded"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
